import React, { useState, useEffect } from "react";
import { FormControl, Select, MenuItem } from "@mui/material";
import { capitalizeAndFormat } from "../../reusableComponent/CapitalLetter";
import { format, parseISO } from "date-fns";
import ReactModal from "react-modal";
import { useCampaignChangeStatusQuery } from "../../../Services/campign/campignList";
import ChangeStatusCampaignModal from "../../../pages/campaign/leads/ChangeStatusCampaignModal";
import { maskPhoneNumber } from "../../reusableComponent/MaskedFields";
import { toast } from "react-toastify";
import { useAddContactMutation } from "../../../Services/customer/FrontendCustomer";
import ChangeUserModal from "../../ticket/ticketListInfo/ChangeUserModal";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import "../../ticket/TicketListInfoCard.scss";  
// src/components/ticket/TicketListInfoCard.scss

const isMobile = window.innerWidth < 600;

const customModalStyles: any = {
  content: {
    top: isMobile ? "0" : "50%",
    left: isMobile ? "0" : "50%",
    right: "auto",
    bottom: "auto",
    transform: isMobile ? "none" : "translate(-50%, -50%)",
    width: isMobile ? "100%" : "100%",
    maxWidth: isMobile ? "100%" : "550px",
    height: "auto",
    maxHeight: isMobile ? "600px" : "700px",
    overflowY: "auto",
    padding: "20px",
    borderRadius: isMobile ? "0" : "12px",
    display: "block",
  },
};

const CampignLeadCardInfo = ({
  campign,
  refetch,
  refetchAuditTrailData,
  setGetAllStatus,
  loading,
  liftingObj,
  setIsStatusWonSelected,
  isStatusWonSelected,
}) => {
  const [selectedStatus, setSelectedStatus] = useState("");
  const [storingTicketId, setStoringTicketId] = useState("");
  const [originalStatus, setOriginalStatus] = useState("");
  const [isStatusModalOpen, setStatusModalOpen] = useState(false);
  const [selectedAllStatus, setAllSelectedStatus] = useState("");
  const [isAddNewContactModalOpen, setAddNewContactModalOpen] = useState(false);
  const [statusOptions, setStatusOptoions] = useState([]);
  const [isWonSelected, setIsWonSelected] = useState(false);
  const [defaultSelect, setDefaultSelect] = useState("");

  const { data: campaignData, refetch: refetchAuditTrail } =
    useCampaignChangeStatusQuery(campign?.campaign?.id, {
      skip: campign?.campaign?.id === undefined,
    });

  const checkUserRole = localStorage.getItem("user_role");
  const [trigger] = useAddContactMutation();

  const truncateDescription = (description, maxLength) => {
    if (description?.length > maxLength) {
      return description?.slice(0, maxLength) + "...";
    }
    return description;
  };

  const getStatusStyle = (status_type: string) => {
    switch (status_type) {
      case "active":
        return "active";
      case "closed":
        return "closed";
      case "reopen":
        return "reopen";
      case "wip":
        return "wip";
      default:
        return "";
    }
  };

  const capitalizeFirstLetter = (string: string | undefined | null) => {
    if (!string) {
      return "";
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 120,
      },
    },
  };

  const handleStatusChange = (campignId) => {
    setStoringTicketId(campignId?.id);
  };

  const openStatusModal = () => {
    setOriginalStatus(selectedStatus);
    setStatusModalOpen(true);
  };

  const closeStatusModal = () => {
    setSelectedStatus(originalStatus);
    setStatusModalOpen(false);
    refetch();
  };

  const handlerStatus = (allStatus) => {
    const formattedStatus = capitalizeFirstLetter(allStatus?.status);
    setIsStatusWonSelected(formattedStatus);
    setAllSelectedStatus(allStatus);
    setSelectedStatus(allStatus.status_type);
    openStatusModal();
  };

  useEffect(() => {
    if (isStatusWonSelected === "Won" || isStatusWonSelected === "Sales order") {
      setIsWonSelected(true);
    }
  }, [isStatusWonSelected]);

  const formatStatusData = (status) => {
    if (status.status_type === "active" || status.status_type === "reopen") {
      return {
        status_type: status.status_type,
        status:
          status.status_type === "active" || status.status_type === "reopen"
            ? status.status
            : status.status[0],
      };
    } else {
      return {
        id: status.status.id,
        status_type: status.status_type,
        status: status.status.status,
      };
    }
  };

  const creatingNewContactDetails = async () => {
    if (isWonSelected) {
      try {
        const response = await trigger(liftingObj);

        if (response?.data) {
          toast.success("Added successfully");
          localStorage.removeItem("dynamicData");
        } else if (response?.error) {
          const error = response.error as {
            data?: { email?: string[]; name?: string[] };
          };
          const errorEmail = error?.data?.email?.[0];
          const errorName = error?.data?.name?.[0];
          const errorMessage = errorEmail || errorName || "An error occurred";

          setIsWonSelected(false);
          toast.error(errorMessage);
        }
      } catch (error) {
        toast.error("An unexpected error occurred");
        setIsWonSelected(false);
      }
    }
  };

  useEffect(() => {
    setDefaultSelect(campign?.status_display || "");
  }, [campign]);

  useEffect(() => {
    if (campaignData) {
      const statusOptions = campaignData?.results[0]?.all_statuses?.map(
        (status) => formatStatusData(status)
      );
      setStatusOptoions(statusOptions);
    }
  }, [campaignData]);

  const handleStatusUpdate = () => {
    setStatusModalOpen(false);
  };

  const openContactModal = () => {
    setAddNewContactModalOpen(true);
  };

  const closeContactModal = () => {
    setAddNewContactModalOpen(false);
  };

  const assigneeName = campign?.assignee?.username
    ? `${campign?.assignee?.username} `
    : "Unassigned";

  localStorage.setItem("assigneeName", assigneeName);

  const formatDate = (dateString: string) => {
    try {
      const date = parseISO(dateString);
      return format(date, "dd-MM-yyyy HH:mm:ss");
    } catch (error) {
      console.error("Invalid date:", dateString);
      return "Invalid date";
    }
  };

  const checkTenant = localStorage.getItem("circleone-user")?.toLowerCase();

  const getPhoneNumber = (phoneNumber, role) => {
    const rolesToMask = ["agent"];
    const restrictedTenants = ["briezi"];
    const isRestrictedTenant =
      checkTenant && restrictedTenants.includes(checkTenant);

    return rolesToMask.includes(role) && isRestrictedTenant
      ? maskPhoneNumber(phoneNumber)
      : phoneNumber;
  };

  const getPriorityColor = (isHighPriority: boolean) => {
    return isHighPriority ? "#dc2626" : "#10b981";
  };

  return (
    <div className="ticket-info-card">
      <div className="ticket-header">
        <div className="header-top">
          <span className="ticket-id">{campign?.id}</span>
          <h3 className="ticket-title">{campign?.title}</h3>
          <span className="ticket-date">{formatDate(campign?.created)}</span>
        </div>

        <div className="header-bottom">
          <span
            className={`status-badge-lead ${getStatusStyle(campign?.status_type)}`}
            title={campign?.status_display}
          >
            {truncateDescription(campign?.status_display, 25)}
          </span>

          <span className="ticket-description" title={campign?.description}>
            {truncateDescription(campign?.description, 120)}
          </span>

          <div className="ticket-actions">
            <div className="assignee-section">
              <span className="assignee-name">
                Assignee:{" "}
                {capitalizeAndFormat(assigneeName.split("@")[0] ?? "Unassigned")}
              </span>
              <KeyboardArrowDownIcon
                className="dropdown-icon"
                onClick={openContactModal}
                sx={{ fontSize: 35 }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="ticket-details-bar">
        <div className="detail-item">
          <span className="detail-label">Assignee</span>
          <span className="detail-value">
            {capitalizeAndFormat(
              campign?.assignee?.username.split("@")[0] ?? "Unassigned"
            )}
          </span>
        </div>

        <div className="detail-item">
          <span className="detail-label">Account Name</span>
          <span className="detail-value">
            {capitalizeFirstLetter(campign?.account_name) || "-"}
          </span>
        </div>

        <div className="detail-item">
          <span className="detail-label">Created By</span>
          <span className="detail-value">
            {capitalizeFirstLetter(campign?.created_by?.username) || "-"}
          </span>
        </div>

        <div className="detail-item">
          <span className="detail-label">Priority</span>
          <span
            className="priority-value"
            style={{ color: getPriorityColor(campign?.is_high_priority) }}
            title={
              campign?.is_high_priority
                ? "High Priority"
                : "Low Priority"
            }
          >
            {capitalizeFirstLetter(campign?.is_high_priority ? "High" : "Low")}
          </span>
        </div>

        <div className="detail-item">
          <span className="detail-label">Workflow</span>
          <span className="detail-value">
            {capitalizeFirstLetter(campign?.campaign?.campaign_name?.name) || "-"}
          </span>
        </div>

        <div className="detail-item">
          <span className="detail-label">Created At</span>
          <span className="detail-value">{formatDate(campign?.created)}</span>
        </div>

        <div className="detail-item">
          <span className="detail-label">Current Team</span>
          <span className="detail-value">
            {capitalizeFirstLetter(campign?.campaign?.team?.name) || "-"}
          </span>
        </div>

        <div className="detail-item">
          <span className="detail-label">Mobile No.</span>
          <span className="detail-value">
            {getPhoneNumber(campign?.phone_number, checkUserRole) || "-"}
          </span>
        </div>

        <div className="detail-item status-select-item">
          <span className="detail-label">Change Status</span>
          <FormControl className="status-select-control">
            <Select
              labelId="status-select-label"
              id="status-select"
              value={defaultSelect}
              MenuProps={MenuProps}
              displayEmpty
            >
              {statusOptions?.map((status) => (
                <MenuItem
                  key={status.id}
                  value={status.status}
                  onClick={() => handlerStatus(status)}
                  title={status?.status}
                >
                  {truncateDescription(status?.status, 25)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>

      <ReactModal
        isOpen={isAddNewContactModalOpen}
        onRequestClose={closeContactModal}
        style={customModalStyles}
        contentLabel="Change User"
        shouldCloseOnOverlayClick={false}
      >
        <ChangeUserModal
          closeModal={closeContactModal}
          refetch={refetch}
          refetchAuditTrailForwardedData={refetchAuditTrailData}
          userChangeType="Lead"
          statusType={campign?.status_type}
          refetchEmailTrail={""}
        />
      </ReactModal>

      <ReactModal
        isOpen={isStatusModalOpen}
        onRequestClose={closeStatusModal}
        style={customModalStyles}
        contentLabel="Change Status"
        shouldCloseOnOverlayClick={false}
      >
        <ChangeStatusCampaignModal
          data={campaignData}
          closeStatusModal={closeStatusModal}
          refetch={refetch}
          refetchAuditTrail={refetchAuditTrail}
          selectedStatus={selectedStatus}
          handleStatusUpdate={handleStatusUpdate}
          selectedAllStatus={selectedAllStatus}
          storingTicketId={storingTicketId}
          refetchAuditTrailData={refetchAuditTrailData}
          creatingNewContactDetails={creatingNewContactDetails}
          campign={campign}
        />
      </ReactModal>
    </div>
  );
};

export default CampignLeadCardInfo;